var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 486.4 486.4",
    style: {
      enableBackground: "new 0 0 486.4 486.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M416.7,11.4c-7-2.9-15-1.3-20.3,4l-48.2,48.2C270.8,7.6,161.9,14.1,92.3,83.8l-19.7,19.7 c-15.1,15.1-15.1,39.7,0,54.9c7.6,7.6,17.5,11.4,27.4,11.4c9.9,0,19.9-3.8,27.4-11.4l19.7-19.7c39.3-39.3,99.1-45.5,145.1-19 l-43.3,43.3c-5.3,5.3-6.9,13.4-4.1,20.3c2.9,7,9.7,11.5,17.2,11.5h147.4c10.3,0,18.7-8.4,18.7-18.6V28.7 C428.2,21.1,423.6,14.3,416.7,11.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M359,328l-19.7,19.7c-22.7,22.7-52.9,35.2-85,35.2c-21.5,0-42-5.7-60.1-16.2l43.3-43.3 c5.4-5.3,6.9-13.3,4.1-20.3c-2.9-6.9-9.7-11.5-17.2-11.5H76.9c-10.3,0-18.7,8.3-18.7,18.6v147.4c0,7.5,4.5,14.3,11.5,17.2 c7,2.9,15,1.3,20.3-4.1l48.1-48.1c33.6,24.4,73.7,37.8,116,37.8c52.9,0,102.5-20.6,139.9-58l19.7-19.7c15.1-15.2,15.1-39.7,0-54.9 C398.7,312.9,374.1,312.9,359,328z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSync);
export default __webpack_public_path__ + "static/media/button-sync.4b42bdd7a05714f049735872d5777093.svg";
export { ForwardRef as ReactComponent };